/**
 * Versión de Rumbo para Ajustes. La imagen que se construye al publicar una
 * versión (etiqueta vX.Y.Z) lleva esa etiqueta en REACT_APP_VERSION_RUMBO;
 * las construcciones de master no la llevan y se identifican por el commit.
 */
export function versionRumbo(
  etiqueta: string | null | undefined,
  commit: string | null | undefined,
): { version: string | null; commit: string | null } {
  const limpia = etiqueta?.trim().replace(/^v/, '') || null;
  const valida = limpia && /^\d+\.\d+\.\d+/.test(limpia) ? limpia : null;
  return { version: valida, commit: commit ? commit.slice(0, 7) : null };
}
